export default "__VITE_ASSET__CBnvRoTI__"